module.exports = __webpack_public_path__ + "static/media/GenistaLogo.33c7903c.svg";